// The University of San Francisco's undergraduate majors. Read on
// 2026-10-01 from the official 2026-2027 Catalog (catalog.usfca.edu,
// catoid=42): the Undergraduate and Graduate Academic Programs page's
// "Undergraduate Majors" list, grouped by the school whose catalog page
// links each program (College of Arts and Sciences, School of Management,
// School of Nursing and Health Professions). The catalog blocks plain curl,
// so the pages were read with a headless browser. Concentrations (and the
// ACS-certified Chemistry and Honors versions) are folded into one line per
// major. Degrees: the School of Management page groups its majors under the
// Bachelor of Science in Business Administration (BSBA) and the Bachelor of
// Arts in Management (BAM); Computer Science, Data Science and Artificial
// Intelligence pages say Bachelor of Science; the Performing Arts and Social
// Justice page says Bachelor of Arts; the Nursing page says BSN. The other
// program pages name no degree, so it is left null rather than guessed.
// Left out: minors, certificates, 4+1, 3+1 and other combined programs, and
// graduate programs.
const majors = {
    "slug": "university-of-san-francisco",
    "read": "2026-10-01",
    "intro": "Every undergraduate major in USF's official 2026-2027 Catalog, grouped by the school that offers it, with the degree where the catalog names it. Concentrations are folded into their major; minors, certificates, combined and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "USF 2026-2027 Catalog, College of Arts and Sciences",
                "url": "https://catalog.usfca.edu/content.php?catoid=42&navoid=9159"
            },
            "majors": [
                {
                    "name": "Advertising",
                    "degree": null
                },
                {
                    "name": "Architecture",
                    "degree": null
                },
                {
                    "name": "Art History & Museum Studies",
                    "degree": null
                },
                {
                    "name": "Artificial Intelligence",
                    "degree": "BS"
                },
                {
                    "name": "Asian Studies",
                    "degree": null
                },
                {
                    "name": "Biology",
                    "degree": null
                },
                {
                    "name": "Biotechnology and Bioentrepreneurship",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Communication Studies",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Critical Diversity Studies",
                    "degree": null
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Design",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Education: Liberal Studies",
                    "degree": null
                },
                {
                    "name": "Engineering",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Environmental Science",
                    "degree": null
                },
                {
                    "name": "Environmental Studies",
                    "degree": null
                },
                {
                    "name": "Fine Arts",
                    "degree": null
                },
                {
                    "name": "Global Studies",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "Kinesiology",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Media Studies",
                    "degree": null
                },
                {
                    "name": "Neuroscience",
                    "degree": null
                },
                {
                    "name": "Performing Arts and Social Justice",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Politics",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Theology and Religious Studies",
                    "degree": null
                }
            ]
        },
        {
            "name": "School of Management",
            "source": {
                "label": "USF 2026-2027 Catalog, School of Management",
                "url": "https://catalog.usfca.edu/content.php?catoid=42&navoid=9168"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BSBA"
                },
                {
                    "name": "Business Analytics",
                    "degree": "BSBA"
                },
                {
                    "name": "Entrepreneurship and Innovation",
                    "degree": "BSBA"
                },
                {
                    "name": "Finance",
                    "degree": "BSBA"
                },
                {
                    "name": "International Business",
                    "degree": "BSBA"
                },
                {
                    "name": "Management",
                    "degree": "BSBA, BAM"
                },
                {
                    "name": "Marketing",
                    "degree": "BSBA"
                }
            ]
        },
        {
            "name": "School of Nursing and Health Professions",
            "source": {
                "label": "USF 2026-2027 Catalog, School of Nursing and Health Professions",
                "url": "https://catalog.usfca.edu/content.php?catoid=42&navoid=9169"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN"
                },
                {
                    "name": "Public Health",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
